import { FC, useRef } from "react";

import { SVGIcon } from '../../../wrappers/SVGIcon';

interface IDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  closeIcon?: string; // Allow closeIcon to be user defined
}

const Drawer: FC<IDrawerProps> = (props) => {
  const { isOpen, onClose, title, children, closeIcon = null } = props;
  const drawerRef = useRef<HTMLDivElement>(null);

  // Handle clicks on overlay to close drawer
  const handleOverlayClick = () => {
    onClose();
  };

  return (
    <>
      {isOpen && (
        <button
          className="immersion__drawer_overlay"
          onClick={handleOverlayClick}
          aria-label="Close drawer"
          type="button"
        />
      )}

      <div
        className={`immersion__drawer_component ${isOpen ? "open" : "close"}`}
        ref={drawerRef}
      >
        <div className="immersion__drawer_component_header">
          <div className="immersion__drawer_component_header_title">{title}</div>
          <div className="immersion__drawer_component_header_icons">
            <button onClick={onClose} className="close-button">
              <SVGIcon src={closeIcon} color="dark_grey" />
            </button>
          </div>
        </div>

        <div className="immersion__drawer_component_document_view">{children}</div>
      </div>
    </>
  );
};

export default Drawer;
